import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SpinnerComponent } from '@app/components/spinner';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { AdminThemeService } from '@app/services/admin-theme/admin-theme.service';
import { TenantTheme } from '@skyfit/core-data-library';
import { finalize, Observable } from 'rxjs';
import { AppConfigMobileAppComponent } from './mobile-app/app-config-mobile-app.component';

@Component({
  standalone: true,
  imports: [CommonModule, SpinnerComponent, AppConfigMobileAppComponent],
  selector: 'app-config',
  templateUrl: './app-config.component.html',
})
export class AppConfigComponent implements OnInit {
  private readonly adminThemeService = inject(AdminThemeService);
  private readonly adminTenantService = inject(AdminTenantService);
  private readonly destroyRef = inject(DestroyRef);
  @ViewChild('fileInput') fileInput!: ElementRef;
  isLoading = signal(true);
  selectedFile?: File;
  theme?: TenantTheme;
  mobileTheme$: Observable<TenantTheme>;

  ngOnInit(): void {
    this.mobileTheme$ = this.adminThemeService
      .getTenantMobileTheme(this.adminTenantService.getTenantId())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .pipe(finalize(() => this.isLoading.set(false)));
  }
}
